import { render, staticRenderFns } from "./EditCabinet.vue?vue&type=template&id=7ffdb8fe&"
import script from "./EditCabinet.vue?vue&type=script&lang=ts&"
export * from "./EditCabinet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports